<template>

  <div class="container m-4">    
  <!--
    <nav class="navbar navbar-expand-lg sticky-top navbar-light bg-light mb-4">
      <a class="navbar-brand" href="#">Home</a>
    </nav>    
  -->
  </div>
</template>


<script>
export default {
  name: 'app-navbar',
  data () {
    return {
        currentUrl: location.hostname.toString() + "/#" + this.$route.fullPath
    }
  },
  mounted(){
    
  },
  updated(){
    this.updateUrl();
  },
  methods : {
    updateUrl(){
      this.currentUrl = location.hostname.toString() + "/#" + this.$route.fullPath;
    }
  }
}
</script>

<style scoped >
  li {
    list-style-type: disc;
    display: list-item;
    margin-left: 20px;
  }
</style>